import { render, staticRenderFns } from "./DesignEditor.vue?vue&type=template&id=82bb94aa&"
import script from "./DesignEditor.vue?vue&type=script&lang=ts&"
export * from "./DesignEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports